import axios from "axios";
import {BASE_URL} from "./config";
import {store} from "../store/store";

export const axiosInstance = new axios.create({
    baseURL: BASE_URL
});

// Private Request interceptor
axiosInstance.interceptors.request.use(
    request => {
        request.headers.Authorization = 'Bearer ' + store.getState().auth.token;
        return request;
    },
    error => {
        return Promise.reject(error);
    }
);

export const publicAxiosInstance = new axios.create({
    baseURL: BASE_URL
});

// Public Request interceptor
publicAxiosInstance.interceptors.request.use(
    request => {

        if (request.url === "users/confirm") {
            request.headers["Content-Type"] = "text/plain"
        }

        return request;
    },
    error => {
        return Promise.reject(error);
    }
);
